<form class="m-form"
      @submit.prevent="submit(false)"
      @reset.prevent="reset(false)"
      novalidate>
    <m-accordion-transition>
        <m-message class="m-form__message-summary"
                   v-if="displaySummary"
                   state="error"
                   :close-button="true"
                   ref="summary">
            <ul>
                <li v-for="(errorMessage, index) in summaryMessages"
                    :key="index"
                    v-html="errorMessage">
                </li>
            </ul>
        </m-message>
    </m-accordion-transition>
    <m-toast :open.sync="displayToast"
             position="top-center"
             state="error">
        <p class="m-form__toast-message"
           v-html="toastMessage"></p>
    </m-toast>
    <slot></slot>
</form>
